<span class="iconContainer">
     <span class="iconBg" [ngStyle]="{'background-color':  colorScheme}"></span> 
     <mat-icon class="notificationIcon" [ngStyle]="{'color':  colorScheme}">{{iconName}}</mat-icon>
</span>